import axios from "axios";
import {
   FETCH_SERVICE_FAILURE,FETCH_SERVICE_SUCCESS
} from "../actionTypes";

const Base_Url = process.env.REACT_APP_BASE_URL;

export const fetchServices = (page = 1, limit = 10, searchTerm = "",displaySection="") => {
  return async (dispatch) => {
    try {
      const res = await axios.get(`${Base_Url}/api/service/getServiceList`, {
        params: { page, limit, search: searchTerm, displaySection},
      });
      const availableServices = Array.isArray(res.data.data)
        ? res.data.data.filter((service) => !service.isBlock) 
        : [];

      dispatch({
        type: FETCH_SERVICE_SUCCESS,
        payload: {
          service: availableServices,
          message: res.data.message || "Service fetched successfully",
          totalPages: res.data.totalPages,
          totalRecords: res.data.totalRecords,
          currentPage: res.data.currentPage,
        },
      });
    } catch (err) {
      dispatch({
        type: FETCH_SERVICE_FAILURE,
        payload: err.response?.data?.message || err.message,
      });
    }
  };
};
